const isProd = process.env.NODE_ENV === "production";

const LOCAL_URL = "http://localhost/Zenite.Ria.Web.Resultados/api";
const SERVER_URL = isProd ? document.getElementById('urlApi').value : LOCAL_URL;

const CONTATO = '(xx) xxxx-xxxx';

const SUBDOMANIN = document.getElementById('subdomain')?.value || '';
const APP_URL = '/resultados' + SUBDOMANIN;
const PATH_IMAGEM_1 = SUBDOMANIN.length ? `${SERVER_URL}/home/imagem1${SUBDOMANIN}` : require('../img/logo.png');
const PATH_IMAGEM_2 = SUBDOMANIN.length ? `${SERVER_URL}/home/imagem2${SUBDOMANIN}` : require('../img/iconeSubtitulo.png');

const DEFAULT_PACIENTE = { chave: '', date: '' };
const DEFAULT_MEDICO = { codigo: '', senha: '' };
const DEFAULT_CONVENIO = { codigo: '', senha: '' };
const DEFAULT_PROCEDENCIA = { codigo: '', senha: '' };
const DEFAULT_PACIENTE_TOKEN = { token: '', documento: '' };

export default {
  APP_URL,
  SERVER_URL,
  SUBDOMANIN,
  CONTATO,
  PATH_IMAGEM_1,
  PATH_IMAGEM_2,
  DEFAULT_PACIENTE,
  DEFAULT_MEDICO,
  DEFAULT_CONVENIO,
  DEFAULT_PROCEDENCIA,
  DEFAULT_PACIENTE_TOKEN
};